<template>
    <client-page>
        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap">
                        <h2 class="client-title--xxxl">조직현황</h2>
                    </div>
                    <v-tabs grow hide-slider>
                        <v-tab exact to="/about/organization">사회복지법인</v-tab>
                        <v-tab exact to="/about/organization/domestic">국내사업기관</v-tab>
                    </v-tabs>
                </v-container>
            </section>

            <section class="client-section pt-0">
                <v-container>
                    <v-img src="/images/about/organization/organization.png" alt="" />
                    <workplaces class="mt-40 mt-lg-60" />
                </v-container>
            </section>
        </div>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import Workplaces from "@/components/client/about/workplaces.vue";

export default {
    components: {
        ClientPage,
        Workplaces,
    },
    data() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.v-tabs {
    ::v-deep(.v-slide-group__prev) {
        display: none;
    }
    .v-tab {
        background-color: #f5f5f5;
        &:first-of-type {
            border-top-left-radius: 999px;
            border-bottom-left-radius: 999px;
        }
        &:last-of-type {
            border-top-right-radius: 999px;
            border-bottom-right-radius: 999px;
        }
        &--active {
            background-color: var(--v-primary-base);
            color: #fff;
        }
    }
}
@media (min-width: 768px) {
    .v-tabs {
        ::v-deep(.v-tabs-bar),
        .v-tab {
            height: 60px;
        }
    }
}
</style>